import { render, staticRenderFns } from "./InterfaceEdit.vue?vue&type=template&id=4f313966&scoped=true&"
import script from "./InterfaceEdit.vue?vue&type=script&lang=js&"
export * from "./InterfaceEdit.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceEdit.vue?vue&type=style&index=0&id=4f313966&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f313966",
  null
  
)

export default component.exports